var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2271_188)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "matrix(1 0 0 -1 0 90)",
    fill: "url(#paint0_linear_2271_188)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1228 46.5613C55.8715 46.5613 62.1749 40.2579 62.1749 32.5092C62.1749 24.7604 55.8715 18.457 48.1228 18.457C40.374 18.457 34.0706 24.7604 34.0706 32.5092C34.0706 40.2579 40.374 46.5613 48.1228 46.5613ZM48.1228 34.0704C45.5398 34.0704 43.4387 31.9693 43.4387 29.3864C43.4387 27.3535 44.7479 25.6366 46.5615 24.9899V23.1409C46.5615 22.278 47.2598 21.5796 48.1228 21.5796C48.9857 21.5796 49.684 22.278 49.684 23.1409V24.9899C51.4976 25.6366 52.8068 27.3535 52.8068 29.3864C52.8068 30.2493 52.1084 30.9477 51.2455 30.9477C50.3824 30.9477 49.6842 30.2493 49.6842 29.3864C49.6842 28.5249 48.9828 27.8251 48.1229 27.8251C47.263 27.8251 46.5616 28.5249 46.5616 29.3864C46.5616 30.2479 47.263 30.9477 48.1229 30.9477C50.7059 30.9477 52.807 33.0488 52.807 35.6317C52.807 37.6646 51.4978 39.3815 49.6842 40.0282V41.8772C49.6842 42.7402 48.9858 43.4385 48.1229 43.4385C47.26 43.4385 46.5616 42.7402 46.5616 41.8772V40.0282C44.7481 39.3815 43.4389 37.6646 43.4389 35.6317C43.4389 34.7688 44.1373 34.0704 45.0002 34.0704C45.8631 34.0704 46.5615 34.7688 46.5615 35.6317C46.5615 36.4932 47.2628 37.193 48.1228 37.193C48.9827 37.193 49.684 36.4932 49.684 35.6317C49.684 34.7702 48.9827 34.0704 48.1228 34.0704ZM18.457 54.3681V69.9815C18.457 70.8437 19.1561 71.5428 20.0183 71.5428H26.2637C27.1259 71.5428 27.8249 70.8437 27.8249 69.9815V52.8066H20.0181C19.1561 52.8068 18.457 53.5057 18.457 54.3681ZM71.0856 53.2642C71.0833 53.2619 71.081 53.2596 71.0787 53.2573C69.3677 51.5477 66.6197 51.4916 64.8378 53.1267L55.4233 61.7646C55.0303 62.1265 54.4883 62.2489 54.0083 62.132L40.0171 58.8217C39.1785 58.6234 38.6601 57.7833 38.8584 56.9431C39.0535 56.1045 39.8892 55.5845 40.737 55.7844L50.4538 58.0832C52.8439 58.6487 55.2484 57.2003 55.8636 54.8227C55.8705 54.7959 55.8772 54.7696 55.8838 54.7429C56.0913 53.9074 55.5819 53.061 54.7464 52.8537L42.2555 49.731C42.0054 49.667 41.7493 49.667 41.4993 49.731L30.948 52.104V68.6269L54.1731 71.5305C54.2403 71.538 54.3043 71.5426 54.3684 71.5426C54.7801 71.5426 55.1765 71.3795 55.4723 71.0852L71.0859 55.4718C71.6954 54.862 71.6954 53.8741 71.0856 53.2642Z",
    fill: "url(#paint1_linear_2271_188)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_188",
    x1: 45,
    y1: 90,
    x2: 45,
    y2: -14.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2271_188",
    x1: 45,
    y1: 18.457,
    x2: 45,
    y2: 71.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.fdf21629a809dac97909960f7d265f0a.svg";
export { ForwardRef as ReactComponent };